import loginService from '@/services/loginService';
import tokenService from '@/services/tokenService';
import { LOGGED_IN } from '@/store/types/MutationTypes';
import { LOGGED_OUT } from '@/store/types/MutationTypes';
import VueI18n from 'vue-i18n';

const { VUE_APP_API_ACCESS_KEY } = process.env;

export default {
    async login({ commit }: any, { i18n, accessKey }: ILoginPayload) {
    try {
      const user = await loginService.login(accessKey);
      commit(LOGGED_IN, user);

      if (i18n && user.idioma) {
          i18n.locale = user.idioma.substr(0, 2);
        }

    } catch (err) {
        commit('setError', { status: 401, message: 'login-invalido' });

    }
  },
  async clearToken({ commit }: any) {
    await tokenService.clearToken();
    commit(LOGGED_OUT);
  },
};

interface ILoginPayload {
    i18n?: VueI18n;
    accessKey?: any;
}
